import "./css/profile.css";
import { Outlet, Link, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import Footer from "./../footer/footer"

const Profile = () => {
    const [showMenu, setShowMenu] = useState(false);
    const [isMounted, setIsMounted] = useState(false);
    const navigate = useNavigate();

    const containerRef = useRef(null);   // Page content reference
    const menuRef = useRef(null);        // Sidebar box reference

    /* ------------------ AUTH CHECK ------------------ */
    useEffect(() => {
        const invalid =
            !localStorage.getItem("name") ||
            !localStorage.getItem("email") ||
            !localStorage.getItem("status") ||
            !localStorage.getItem("token") ||
            !localStorage.getItem("user_id");

        if (invalid) {
            localStorage.clear();
            navigate("/login");
        }
    }, [navigate]);

    /* ------------------ MENU STATE RESTORE ------------------ */
    useEffect(() => {
        const saved = sessionStorage.getItem("profileMenu");
        if (saved !== null) setShowMenu(saved === "true");
        setIsMounted(true); // Mark as mounted after initial render
    }, []);

    const toggleMenu = () => {
        const newState = !showMenu;
        setShowMenu(newState);
        sessionStorage.setItem("profileMenu", newState);
    };

    /* ------------------ SIDEBAR RESIZE HANDLER ------------------ */
    useEffect(() => {
        // Only run after component is mounted and refs are available
        if (!isMounted || !containerRef.current || !menuRef.current) return;

        const updateSidebarHeight = () => {
            try {
                const container = containerRef.current;
                const menu = menuRef.current;
                
                if (!container || !menu) return;
                
                const height = container.getBoundingClientRect().height;
                menu.style.height = height > 910 ? `${height}px` : "89vh";
            } catch (error) {
                console.error("Error updating sidebar height:", error);
            }
        };

        const observer = new ResizeObserver(updateSidebarHeight);
        
        // Add delay to ensure DOM is ready
        const timeoutId = setTimeout(() => {
            if (containerRef.current) {
                observer.observe(containerRef.current);
                updateSidebarHeight(); // Initial height
            }
        }, 100);

        return () => {
            clearTimeout(timeoutId);
            observer.disconnect();
        };
    }, [isMounted, showMenu]); // Added showMenu dependency to update on toggle

    /* ------------------ SAFE HEIGHT UPDATE ON WINDOW RESIZE ------------------ */
    useEffect(() => {
        if (!isMounted || !containerRef.current || !menuRef.current) return;

        const handleResize = () => {
            try {
                const container = containerRef.current;
                const menu = menuRef.current;
                
                if (!container || !menu) return;
                
                const height = container.getBoundingClientRect().height;
                menu.style.height = height > 910 ? `${height}px` : "calc( 100vh - 70px)";
            } catch (error) {
                console.error("Error on resize:", error);
            }
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [isMounted]);

    return (
        <div className="profilePageWrapper">
            <div className="profileMainContainer">

                {/* Mobile Menu Icon */}
                <div className="profileSideboxIcon">
                    <div className="profileSideboxIconBox" onClick={toggleMenu}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

                {/* Sidebar */}
                <div className={showMenu
                    ? "profileSideMenuContainer showNavMenu"
                    : "profileSideMenuContainer hideNavMenu"
                }>
                    <div className="profileSideMenubox" ref={menuRef}>
                        <div className="profileMenuSideInnerContainer">
                            <ul>
                                <li><Link to="/profile">Dashboard</Link></li>
                                <li><Link to="/profile/result">Result</Link></li>
                                <li><Link to="/profile/showCourse">Courses</Link></li>
                                <li><Link to="/profile/changePassword">Change Password</Link></li>
                                <li className="dangerLink"><Link to="/profile/deleteAccount">Delete Account</Link></li>
                            </ul>
                        </div>
                    </div>

                    {/* Sidebar Close Icon */}
                    <div className="profileSideMenuboxIcon">
                        <div className="profileSideMenuboxIconBox" onClick={toggleMenu}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>

                {/* Page Content - Added loading fallback */}
                <div className="profilePageContainer" ref={containerRef}>
                    {isMounted ? <Outlet /> : <div className="loadingText">Loading dashboard...</div>}
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default Profile;